import React, { useState,useContext } from "react";
import Dentist from '../Another/Dentist/Dentist';
import Feature from '../Another/Feature/Feature';
import Service from '../Another/Service/Service';
import About from '../About/About';
import Navbar from "../../Basic/Navbar";
import Footer from "../../Basic/Footer";
import { useNavigate ,useLocation} from "react-router-dom";
import {authContext} from "../../../Context/AuthContext"
import Banner from '../Banner/Banner';


const Home = () => {
    // ?token=${Token},refreshToken=${refreshToken},role=${oldUser.role},email=${oldUser.email}
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');
    const refreshToken = queryParams.get('refreshToken');
    const role = queryParams.get('role');
    const email = queryParams.get('email');
    const name = queryParams.get('name');
    const {login,setTokenTo,setEmailTo,setRefTokenTo,setRoleTo,setNameTO} = useContext(authContext)
    if(token){
        login()
        setTokenTo(token)
        setEmailTo(email)
        setRefTokenTo(refreshToken)
        setRoleTo(role)
        setNameTO(name)
    }
    
    return (
        <>
           <Navbar />
           <Banner />
           <Feature />
           <About />
           <Service />
           <Dentist />
           <Footer />
        </>
    );
};

export default Home;